import Dialog from "dialog";
import template from "../html/dialog-config-co2.html";
import css from "../css/dialog-config-co2.css";

class ConfigCO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-co2", ConfigCO2Dialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.co2Sensor.id;
    this.textboxDeviceStatus.value = devices.co2Sensor.status;
    this.textboxValue.value = devices.co2Sensor.value;
    this.textboxTemperature.value = devices.co2Sensor.temperature;
    this.textboxRelativeHumidity.value = devices.co2Sensor.relativeHumidity;
  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonCalibrateNitrogen_click(event) {
    try {
      this.buttonCalibrateNitrogen.icon.iconname = "view-refresh";
      await server.rcall("RM_co2sensor_calibratenitrogen");
      this.buttonCalibrateNitrogen.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateNitrogen.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateFreshAir_click(event) {
    try {
      this.buttonCalibrateFreshAir.icon.iconname = "view-refresh";
      await server.rcall("RM_co2sensor_calibratefreshair");
      this.buttonCalibrateFreshAir.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateFreshAir.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateKnownGas_click(event) {
    try {
      this.buttonCalibrateKnownGas.icon.iconname = "view-refresh";
      await server.rcall("RM_co2sensor_calibrateknowngas", parseInt(this.textboxCalibrateKnownGas.value));
      this.buttonCalibrateKnownGas.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateKnownGas.icon.iconname = "process-stop";
    }
  }
  close() {
    super.close();
  }
}

ConfigCO2Dialog.constructor();

export default ConfigCO2Dialog;